import { Button as MuiButton, ButtonProps as MuiButtonProps, styled } from "@mui/material";
import React, { forwardRef } from "react";

import { colors } from "@/Utils";

import { brandColors } from "../../utils/brand-colors";

const StyledButton = styled(MuiButton)(({ theme }) => {
  return {
    borderColor: "#79747E",
    backgroundColor: theme.palette.mode === "light" ? brandColors.ceasefireWhite : colors.gray,
    color: theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,

    borderRadius: "6.25rem",
    textTransform: "none",
    padding: "0.25rem 1.25rem",
    width: "fit-content",

    "&:hover": {
      borderColor: "#79747E",
    },
  };
});

interface ButtonProps extends MuiButtonProps {
  children: React.ReactNode;
}

export const OutlinedButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledButton ref={ref} {...props}>
        {children}
      </StyledButton>
    );
  }
);

export default OutlinedButton;
